export const FETCH_NON_AUTH_ACTIVITY = "fetch-non-auth-activity";
